/**
 * EntityOrchardRpin
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectParentEntityOrchardRpin, makeSelectEntityOrchardRpin } from '../../services/entities/selectors';

interface Props {
    orchardRpin?: string;
}

export class EntityOrchardRpin extends React.PureComponent<Props> {
    static defaultProps = {
        orchardRpin: null
    };

    render() {
        const { orchardRpin } = this.props;
        return orchardRpin;
    }
}

const mapStateToProps = createStructuredSelector({
    orchardRpin: makeSelectParentEntityOrchardRpin(),
});

export default connect(mapStateToProps)(EntityOrchardRpin);
